import MenuIcon from '@mui/icons-material/Menu';
import { Link, useMediaQuery } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { CSSObject, Theme, styled, useTheme } from '@mui/material/styles';
import { useAppThemeContext } from 'app/shared/contexts/ThemeContext';
import { Home } from 'app/shared/layout/header/header-components';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import { Translate } from 'react-jhipster';
import { useHistory } from 'react-router-dom';
export interface IDrawerProps {
  isAuthenticated: boolean;
  open: boolean;
  setOpen: (value: boolean) => void;
}

const drawerWidth = 280;

const openedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: theme.palette.primary.main,
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  backgroundColor: theme.palette.primary.main,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('md')]: {
    width: `calc(${theme.spacing(11)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: prop => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export const ChecklistFacilDrawer = (props: IDrawerProps) => {
  const history = useHistory();
  const theme = useTheme();
  useAppThemeContext();
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;
  const drawerRef = useRef(null);
  const listRef = useRef(null);
  const isXsToMd = useMediaQuery(theme.breakpoints.between('xs', 'md'));
  const logoChecklistFacil =
    initialTheme === 'light'
      ? '../../../content/images/checklist-facil/logo-checklistfacil-default.png'
      : '../../../content/images/checklist-facil/logo-checklistfacil-white.png';

  const handleDrawer = () => {
    props.setOpen(!props.open);
  };

  const handleLogoClick = () => {
    history.push('/dashboards');
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        if (!event.target.closest('svg')) {
          props.setOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <Drawer
        anchor="left"
        variant="permanent"
        open={props.open}
        ref={drawerRef}
        sx={{
          display: props.open ? 'flex' : isXsToMd ? 'none' : 'block',
        }}
      >
        <DrawerHeader onClick={() => handleLogoClick()}>
          <img src={logoChecklistFacil} alt="Checklist Fácil" style={{ cursor: 'pointer', width: '60%', maxWidth: '160px' }} />
        </DrawerHeader>

        <List ref={listRef}>
          <ListItemButton
            onClick={handleDrawer}
            sx={{
              pl: { xs: '18px', md: '32px' },
            }}
          >
            <ListItemIcon aria-label="open drawer">
              <MenuIcon />
            </ListItemIcon>
            <ListItemText
              primary={<Translate contentKey="global.menu.menu">Menu</Translate>}
              primaryTypographyProps={{
                fontSize: '14px',
              }}
              sx={{
                opacity: open ? 1 : 0,
                fontWeight: open ? '600' : '400',
              }}
            />
          </ListItemButton>

          {props.isAuthenticated && <Home drawerIsOpen={props.open} />}

          {!!props.open && (
            <ListItemButton
              component={Link}
              href="https://www.sigaway.com.br/"
              target="_blank"
              sx={{
                position: 'fixed',
                bottom: 0,
                width: '264px',
                backgroundColor: initialTheme === 'dark' ? '#000814' : '#f7f6f3',
                pl: { xs: '18px', md: '32px' },
              }}
            >
              <ListItemText
                primary="sigaway.com.br"
                primaryTypographyProps={{
                  fontSize: '14px',
                  color: '#999999',
                }}
              />
            </ListItemButton>
          )}
        </List>
      </Drawer>
    </>
  );
};
